import { csv } from 'd3';
import _ from 'lodash';
import { data_folder } from '../inputs/data_paths';
import { getDataPointKey } from './utils.js'

const data_points_path = `${data_folder}data/RecLimitsAndDescriptions.csv`;

const loadMetaData = async () => {
    const meta_data = {};

    await csv(data_points_path, (d, i) => {

        _.forEach(["RecLimit"], (prop) => {
            d[prop] = parseFloat(d[prop]);
        });

        // add data point to group
        meta_data[getDataPointKey(d)] = d;  
    });

    return meta_data;
};

export default loadMetaData;